import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  options = {
    threshold: 1
  }

  connect() {
    this.createObserver();
    document.dispatchEvent(new CustomEvent("page:render"))
  }

  appear(entry) {
    if (this.loading) return;
    this.loading = true;
    this.observer.disconnect();
    this.element.innerHTML = "Loading ..."
    this.element.click()
    this.element.classList.add("is-loading")
  }

  createObserver() {
    this.observer = new IntersectionObserver(entries => this.handleIntersect(entries), { threshold: 0 });
    this.observer.observe(this.element);
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.appear(entry)
      }
    });
  }
}

